import moment from 'moment-timezone';

const TZ = 'Europe/Berlin';

/**
 * Format a DB datetime value for display.
 * DB DATETIME columns store Europe/Berlin local time. With Sequelize timezone "+00:00",
 * the raw value arrives as UTC-tagged but the numeric part IS already Berlin time.
 * Use moment.utc() to extract the raw value without timezone conversion.
 */
export const formatGermanTime = (
  dateTime: string | Date | moment.Moment,
  pattern: string,
): string => moment.utc(dateTime).format(pattern);

/**
 * Convert a datetime value to `YYYY-MM-DDTHH:mm` for `<input type="datetime-local">`.
 * DB DATETIME columns store Europe/Berlin local time. With Sequelize timezone "+00:00",
 * the raw value arrives as a UTC-tagged ISO string (e.g. "2026-04-03T06:00:00.000Z")
 * but the numeric part IS already Berlin time. Use moment.utc() to extract the raw
 * value without applying timezone conversion.
 */
export const toGermanDatetimeLocal = (dateTime: string | Date | moment.Moment): string =>
  moment.utc(dateTime).format('YYYY-MM-DDTHH:mm');

/** Parse a `datetime-local` input value as Europe/Berlin, returning a moment object */
export const fromGermanDatetimeLocal = (localValue: string): moment.Moment =>
  moment.tz(localValue, TZ);

/**
 * "Now" in the same coordinate system as `moment.utc(<db value>)` — a UTC-mode moment whose
 * wallclock reads Berlin. Use this to compare against DB datetimes; a plain `moment()` is
 * real local time and comparing it to a UTC-tagged Berlin value skews the result by the
 * Berlin offset (1-2h).
 */
export const germanNow = (): moment.Moment =>
  moment.utc(moment().tz(TZ).format('YYYY-MM-DDTHH:mm:ss'));
